module.exports = "https://static.moomoo.com/components/lottery3/images/bg.6cfd1cb224.png";